<template>
<div >
    <div v-if="!quoteRejected" class="col-sm-12 summary-container">
    	<div class="wizard-container pt-0" id="summary-wizard-container">
			<div class="card wizard-card summary-wizard-card" data-color="red">
				<img
					v-if="calculating"
					style="margin: 130px auto 130px auto;"
					class="img-responsive"
					key="calculating"
					:src="loadingImageUrl"
				/>
				<div class="wizard-header summary-wizard-card" v-else>
					<h3 class="wizard-title">Summary</h3>
					<hr style="border-color: #29ABE1;" />

					<div class="row m-b-15" v-if="accidentCover">
						<div class="col-md-12 text-center text-bold">
							Accident Cover
						</div>
						<div class="col-md-12 text-center">
							<p>
								{{ accidentCover.description }}: ${{ accidentCover.price }} <br/>
								{{ accidentCover.insuredIndividual }}
							</p>
						</div>
					</div>

					<div class="row">
						<div class="col-md-12 text-center">
							<p><strong>Total Cost of Insurance Cover</strong></p>
						</div>
					</div>
					<div class="row m-b-15">
						<div class="col-md-12 text-center">
							<h2
								class="m-t-0-i m-b-0-i"
								style="color: #00A99D;"
								v-text="'$'+totalCostOfInsurance.toFixed(2)"
							/>

							<small v-if="summaryData.discount">Discount applied</small>
						</div>
					</div>

					<div class="row m-b-15" v-if="isExemptFromStampDuty">
						<div class="col-md-12 text-center">
							<p class="text-muted eligible-for-stamp-duty">
								<span class="alert alert-success">
									<!-- <span data-notify="icon" class="ti-bell"></span> -->
									<span>Eligible for Stamp Duty Exemption (-${{ ((summaryData.stampDuty !== 'undefined' && summaryData.stampDuty) ? summaryData.stampDuty : 0).toFixed(2) }})</span>
								</span>
							</p>
						</div>
					</div>

					<div class="row m-b-15" v-if="underwriter">
						<div class="col-md-12 text-center text-bold">
							<img
								v-if="underwriter.logo"
								:src="underwriter.logo"
								:alt="underwriter.name"
								width="104"
								height="30" />
							<span v-else>
								{{ underwriter.name }}
							</span>
						</div>
					</div>

					<cost-breakdown-summary></cost-breakdown-summary>

					<div class="row">
						<div class="col-md-12 text-center">
							Monthly Payments: {{ monthlyPayments }}
						</div>
					</div>
					<div class="row m-b-10-i">
						<div class="col-md-12" v-if="monthlyPayments">
							<p class="category text-center m-t-10">
								Monthly payments are only available when checking out with 'Pay by the Month' option.
							</p>
						</div>
					</div>

					<div
						v-if="pendingOrderInfo"
						class="row justify-content-center"
					>
						<p class="text-center mb-0">
							<button
								type="button"
								class="btn btn-link font-14 p-t-0-i"
								data-toggle="collapse"
								data-target="#user-information"
								:aria-expanded="userInformationExpanded ? 'true' : 'false'"
								aria-controls="user-information"
								@click="userInformationExpanded = !userInformationExpanded"
							>
								User information
								<i
									class="fa"
									:class="{
										'fa-caret-up': userInformationExpanded,
										'fa-caret-down': !userInformationExpanded
									}"
								/>
							</button>
						</p>
					</div>

					<div
						v-if="pendingOrderInfo"
						id="user-information"
						:class="{
							'm-b-25': true,
							'collapse': true,
						}"
					>
						<div class="well text-center">
							<div
								class="row justify-content-center"
								v-for="(item, index) in pendingOrderInfo"
								:key="index"
							>
								<div :class="{
									'col-sm-8 ': true,
									'text-bold': item.bold,
								}">{{ item.value }}</div>
							</div>
						</div>
					</div>

					<div class="row p-y-10">
						<div class="col-md-12 text-center">
							<a
								v-if="underwriter.product_liability_policy"
								class="product-disclosure-statement-link m-r-10"
								target="_blank"
								rel="noopener noreferrer"
								:href="underwriter.product_liability_policy"
							>
								Policy Wording
							</a>
							<a
								class="product-disclosure-statement-link"
								target="_blank"
								rel="noopener noreferrer"
								:href="dutyOfDisclosureUrl"
							>
								Duty of Disclosure
							</a>
						</div>
					</div>

					<div class="row text-center">
						<div class="col-md-12 m-b-20">
							<a href="#" @click.prevent="toggleEndorsements">
								Endorsements
							</a>
						</div>
					</div>

					<div class="row" v-if="step == 1 && existingPendingOrder">
						<div class="col-sm-12 m-b-20">
							<request-quote-popup></request-quote-popup>
						</div>
					</div>

					<div
						v-if="showEndorsements"
						v-show="!calculating"
						data-color="red"
						style="min-height: 0px !important;"
					>
						<div class="m-b-20">
							<h3 class="wizard-title">Endorsements</h3>
							<hr style="border-color: #29ABE1;" />
							<ul class="p-b-30 pl-0" v-if="pendingOrder && pendingOrder.endorsements && pendingOrder.endorsements.length > 0">
								<li v-for="(endorsement, index) in pendingOrder.endorsements" :key="index">
									{{ endorsement.description }}
									<a @mouseover="infoMouseOver($event)" @click="showEndorsementDetailsPopup(endorsement)"><span class="ti-info-alt endorsement-info"></span></a>
								</li>
							</ul>
							<p class="text-center p-b-20 pl-0" v-else>No endorsements to display.</p>
						</div>
					</div>
				</div>
				<!--
				<div class="row">
					<div class="col-md-12 text-center m-b-20">
						<img :src="bannerPath2" id="thailand-banner-2-img" alt="" class="img-responsive">
						<p class="banner-tc category m-t-10">*Conditions Apply.Please refer to full <a class="banner-tc-link" target="_blank" :href="bannerUrl">terms &amp; conditions</a>.</p>
					</div>
				</div>
				-->
			</div>
    	</div>
     
    </div>
	 	<div v-bind:class="canShowEndorsementDetailsModal ? 'show' : 'hide'" class="modal" tabindex="-1" role="dialog">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="resetModalEndorsement">
							<span aria-hidden="true">&times;</span>
						</button>
						<h4 class="modal-title">{{ modalEndorsement ? modalEndorsement.description : null}}</h4>
					</div>
					<div class="modal-body">
						<div v-if="modalEndorsement" v-html="modalEndorsement.details"></div>
					</div>
				</div><!-- /.modal-content -->
			</div><!-- /.modal-dialog -->
    	</div><!-- /.modal -->
    <div v-if="!quoteRejected && checkRefer" class="col-sm-12">
    	<div class="refer">
	    	<div class="row">
				<div class="col-md-12 text-center">
					<p><strong>Want to save $10 more? Refer a friend!</strong></p>

					<button
						type="button"
	                    class="btn btn-next btn-refer btn-fill btn-info btn-wd"
						@click="openRefer();"
					>
	                    <!-- <i v-if="emailQuoteDisabled" class="fa fa-spinner fa-spin"></i> -->
						<!-- <i class="fa fa-envelope"></i> -->
						Refer
	              	</button>
				</div>
			</div>
		</div>
    </div>

	<sweet-modal
		ref="referModal"
		overlay-theme="dark"
		:hideCloseButton="true"
	>
		<form @submit.prevent="submitRefer()">
			<h5>Refer a friend!</h5>
			<div class="form-group">
				<label>Name <span class="required-field">*</span></label>
				<input type="text" v-model="referName" class="form-control">
			</div>

			<div class="form-group">
				<label>Email <span class="required-field">*</span></label>
				<input type="email" v-model="email" class="form-control">
			</div>

			<!-- <p>Referal Friend Text</p> -->

			<button
				type="button"
				class="btn btn-wd p-x-45-i btn-blue active"
				v-on:click="submitRefer()">
				Refer a friend and apply discount
			</button>
		</form>

<!-- 		<button class="btn btn-next btn-fill btn-success btn-block btn-wd" :disabled="!enabled" @click.prevent="sendQuote" v-if="!loading">Email My Quote</button> -->
	</sweet-modal>
</div>
</template>

<script>
import { isEmpty, get } from 'lodash'
import { mapState, mapGetters, mapMutations } from 'vuex'
import store from '../store'
import * as appConfigs from '../configs'
import { apiDomain } from '../configs'
import axios from 'axios'
import Cookies from 'js-cookie'
import { generateErrorMessage } from '../helpers'
import CostBreakdownSummary from './CostBreakdownSummary.vue'
import RequestQuotePopup from './RequestQuotePopup'
import { SweetModal } from 'sweet-modal-vue'


export default {
	components: {
		CostBreakdownSummary, RequestQuotePopup, SweetModal
	},
	store,
	data() {
		return {
			modalEndorsement: null,
			email: '',
			referName: '',
			referError: '',
			referShow: true,
			processingEmailForm: false,
			animation: 'calculating',
			userInformationExpanded: false,
		}
	},
	props: {
        pendingOrder: {
			type: Object
		}
    },
	mounted() {
		this.$store.commit("setCalculating", { calculating: false });
	},
	computed: {
		...mapState({
			accidentCover: state => state.accidentCover,
			agreedToTerms: state => state.agreedToTerms,
			calculating: state => state.calculating,
			configs: state => state.configs,
			customerEmail: state => state.customerEmail,
			existingPendingOrder: state => state.existingPendingOrder,
			quoteRejected: state => state.quoteRejected,
			selectedOccupation: state => state.selectedOccupation,
			showEmailBlock: state => state.showEmailBlock,
			showEndorsements: state => state.showEndorsements,
			stateByPostcode: state => state.stateByPostcode,
			step: state => state.step,
			summaryData: state => state.summaryData,
			underwriter: state => state.underwriter,
			usingCreditCard: state => state.usingCreditCard,
    	}),

		...mapGetters([
			'isExemptFromStampDuty',
			'totalCostOfInsurance',
		]),

		canShowEndorsementDetailsModal(){
			return this.modalEndorsement !== null && this.modalEndorsement.length !== 0
		},
		loadingImageUrl(){
			return appConfigs.apiDomain + 'images/summary-loading.gif';
		},
		fsgPdfUrl() {
			return appConfigs.fsgPdfUrl
		},
		checkRefer() {
			if (this.referShow && isEmpty(this.pendingOrder.discount)) {
				return true
			}

			return false
		},
		dutyOfDisclosureUrl(){
			return appConfigs.dutyOfDisclosureUrl
		},
		termsAndConditionsUrl(){
			return appConfigs.termsAndConditionsUrl
		},
		bannerUrl(){
			return appConfigs.bannerUrl
		},
		eFundInterestRate(){
			return appConfigs.eFundInterestRate
		},
		adjustedTotal() {
			if (isEmpty(this.summaryData)) {
				return 0
			}

			let total = this.summaryData.totalPrice || 0

			if (this.accidentCover) {
				total += parseFloat(this.accidentCover.price)
			}
			return (total * this.eFundInterestRate).toFixed(2)
		},
		monthlyPayments() {
			if (isEmpty(this.pendingOrder) || this.pendingOrder.period_of_cover != 12) {
				return 'Not Available'
			}
			let monthlyPayments = (this.adjustedTotal / 10).toFixed(2)
			return `$${monthlyPayments}`
		},
		bannerPath2 () {
			return `${apiDomain}images/thailand-banner-2.jpg`
		},
		pendingOrderInfo () {
			if (isEmpty(this.pendingOrder)) {
				return null
			}

			const fields = {
				name: { bold: true },
				occupation_id: {},
				business_name: {},
				phone: {},
				email: {},
			}

			const info = Object.keys(fields).reduce((out, item) => {
				if (this.pendingOrder.hasOwnProperty(item)) {
					out[item] = {
						...fields[item],
						value: this.pendingOrder[item]
					}
				}
				return out
			}, {})

			const occupation = info.occupation_id && this.configs.occupations && this.configs.occupations.filter(item => item.id == info.occupation_id.value)[0]
			if (occupation) {
				info.occupation_id.value = occupation.business_activity
			}

			return info
		}
	},
  	methods: {
		...mapMutations({
			toggleEndorsements: 'toggleShowEndorsements',
		}),
		// updateCustomerEmail(e) {
		// 	this.$store.commit('updateCustomerEmail', { email: e.target.value })
		// },
		showEndorsementDetailsPopup(endorsement) {
			this.modalEndorsement = endorsement
		},
		resetModalEndorsement(){
			this.modalEndorsement = null
		},
		infoMouseOver(event){
			$(event.target).css( 'cursor', 'pointer' );
		},

		openRefer() {
			this.$refs.referModal.open()
		},

		

		submitRefer() {
			let data = {
				email: this.email,
				name: this.referName
			}

			this.loading = true
			this.$store.commit('setScreenLoader', { showScreenLoader: true })

			axios.post(`${apiDomain}form/refer-friend/${this.pendingOrder.id}`, data).then((res) => {
				this.$store.commit('setScreenLoader', { showScreenLoader: false })

				if (res.status === 200) {
					const pendingOrder = res.data.data
					this.$store.commit('setPendingOrder', { pendingOrder })

					const discount = parseFloat(pendingOrder.discount).toFixed(2);
					this.summaryData.totalPrice = this.summaryData.totalPrice - discount;
					this.summaryData.discount = parseFloat(pendingOrder.discount).toFixed(2)
					const summaryData = this.summaryData

					this.$store.commit('setSummaryData', { summaryData })

					this.referShow = false
					this.$refs.referModal.close()
				}
			}).catch((err) => {
				this.$store.commit('setScreenLoader', { showScreenLoader: false })
				if (err) {
					this.referError = err
				}
			})
		},
  	},
}
</script>

<style lang="scss">
.summary-wizard-card{
	padding-bottom: 0px !important;
}
.wizard-card.summary-wizard-card{
	background-color: #fff !important;
}
	

#summary-wizard-container{
    padding-bottom: 0px !important;
	margin-top: 15px !important;
	
}
.m-t-15 {
	margin-top: 15px;
}
.m-b-20 {
	margin-bottom: 20px;
}
.p-b-30 {
	padding-bottom: 30px;
}
.p-b-20 {
	padding-bottom: 20px;
}
.slide-fade-enter-active {
  transition: all .25s ease;
}
.slide-fade-leave-active {
  transition: all .25s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(20px);
  opacity: 0;
}
@media screen and (max-width: 991px) {
	.wizard-container {
		padding-top: 40px;
		width: 100% !important;
	}
}

#thailand-banner-2-img {
	height: 250px;
  margin: 0px auto;
}

.banner-tc{
  font-size: 12px !important;
}

.eligible-for-stamp-duty {
	color: #00A99D;
	line-height: 32px;
}

.refer {
    background-color: #eeeeee;
    box-shadow: 0 1px 5px -8px rgb(0 0 0 / 57%);
    padding: 20px 0;
}

.sweet-modal-overlay {
	z-index: 1;
}

.btn-link:focus{
	box-shadow: none !important;
}

.btn-refer{
	background-color: #fff;
	color: #009245;
  border:1px solid #009245;
	&:hover{
        border:1px solid #1e98e0;
	}
}
.endorsement-info:hover{
  color: #009245 !important;
}
// .affix {
// 	top: -80px;

// 	@media screen and (max-width: 991px) {
// 		position: static;

// 		&.wizard-container {
// 			padding-top: 40px;
// 			width: 100% !important;
// 		}
// 	}
// }
</style>
